module.exports = __webpack_public_path__ + "img/75-1.f0b1cae3.svg";